import { render, staticRenderFns } from "./EditSupport.vue?vue&type=template&id=18a77faa&"
import script from "./EditSupport.vue?vue&type=script&lang=js&"
export * from "./EditSupport.vue?vue&type=script&lang=js&"
import style0 from "./EditSupport.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSelect,VSheet})
